// schema
import * as ISchema from "@schema";
// libraries
import React from "react";

// components
import { TeamSections } from "../web-settings";

import { TeamSettingsAdminNoMeetingDay } from "@components/teams-settings/team-settings-admin-form/team-settings-admin-no-meeting-day";

// material-ui
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Team No Meeting Day Settings
// ~-~-~-~-~-~-~-
interface TeamNoMeetingDayProps {
  org: ISchema.IOrg;
  team: ISchema.ITeam;
}

const useStyles = makeStyles({
  content: {
    marginBottom: 30,
  },
});

export const TeamNoMeetingDay = (props: TeamNoMeetingDayProps) => {
  const classes = useStyles();

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  const { org, team } = props;

  return (
    <div cw-id={`web-settings-${TeamSections.TeamNoMeetingDay}`} className={classes.content}>
      <Typography variant="h3" className="cw-mb-4">
        Team no-meeting day
      </Typography>
      <Typography variant="subtitle1" className="cw-mb-6">
        Your team can dedicate one day of the week for a “no-meeting day.” Clockwise will try to
        keep that day meeting-free for team members, and can optionally notify meeting organizers
        when they schedule over your team's no-meeting day.{" "}
        <a href={"https://getclockwise.com"} target="_blank">
          Learn more
        </a>
        .
      </Typography>
      <TeamSettingsAdminNoMeetingDay org={org} team={team} isWebSettings />
    </div>
  );
};
